// extracted by mini-css-extract-plugin
export default {"root":"summary-item_root__xwuZ-","title":"summary-item_title__eZRda","danger":"summary-item_danger__5pQA9","placeHolderShimmer":"summary-item_placeHolderShimmer__drNkd"};